export enum IMAGE_STATUS {
    INIT = 'init',
    LOADING = 'loading',
    EMPTY = 'empty',
    FULFILLED = 'fulfilled',
}
